import type { TourStep } from '@/types/help-tour';
import { buildTourSteps, type TourStepDef } from '@/utils/tourI18n';

const STEP_DEFS: TourStepDef[] = [
  { target: '[data-tour="appbar-family-nav"]' },
  { target: '[data-tour="page-breadcrumb"]' },
  { target: '[data-tour="overview-title"]' },
  { target: '[data-tour="screen-help-dot"]' },
  { target: '[data-tour="overview-invite"]' },
  { target: '[data-tour="overview-stats"]' },
  { target: '[data-tour="overview-plan"]' },
  { target: '[data-tour="overview-export-gedcom"]' },
  { target: '[data-tour="overview-dashboard"]' }
];

export const FAMILY_OVERVIEW_TOUR_STEPS: TourStep[] = buildTourSteps('familyOverview', STEP_DEFS);

export const FAMILY_OVERVIEW_TOUR_STORAGE_KEY = 'wetree-family-overview-tour-completed';

export function resolveFamilyOverviewTourSteps(
  steps: TourStep[],
  hasMembers: boolean,
  showPlanMeta = false,
  canExportGedcom = false,
  canInviteMembers = false
): TourStep[] {
  return steps.filter((step) => {
    if (step.target === '[data-tour="overview-invite"]') {
      return canInviteMembers;
    }
    if (!hasMembers && step.target === '[data-tour="overview-plan"]') {
      return false;
    }
    if (!showPlanMeta && step.target === '[data-tour="overview-plan"]') {
      return false;
    }
    if (step.target === '[data-tour="overview-export-gedcom"]') {
      return hasMembers && showPlanMeta && canExportGedcom;
    }
    if (
      !hasMembers &&
      (step.target === '[data-tour="overview-stats"]' || step.target === '[data-tour="overview-dashboard"]')
    ) {
      return false;
    }
    return true;
  });
}
